/**
 * Каталог гидроизоляции. Цвета условные, как на схемах: каждый вид своим цветом,
 * а наплавляемая ещё и с сотами — это уже знает её компонент.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { WaterproofMaterial, type WaterproofCatalogItem } from "./types";

export const waterproofSection: CatalogSection<WaterproofCatalogItem> = {
	kind: LayerKind.Waterproof,
	label: "Гидроизоляция",
	canChangeDimensions: false,
	subGroups: ["Обмазочная", "Рулонная", "Наплавляемая"],
	items: [
		{
			id: "waterproof-coating",
			material: WaterproofMaterial.Coating,
			subGroup: "Обмазочная",
			name: "Обмазочная гидроизоляция",
			description: "Жидкий состав, наносится кистью или валиком в два слоя.",
			color: "#1e3a8a",
		},
		{
			id: "waterproof-roll",
			material: WaterproofMaterial.Roll,
			subGroup: "Рулонная",
			name: "Рулонная гидроизоляция",
			description: "Рулонный материал на битумной основе, укладывается с нахлёстом.",
			color: "#16a34a",
		},
		{
			id: "waterproof-meltable",
			material: WaterproofMaterial.Meltable,
			subGroup: "Наплавляемая",
			name: "Наплавляемая гидроизоляция",
			description: "Битумные рулоны, наплавляются газовой горелкой.",
			color: "#dc2626",
		},
	],
};
